var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddCircle = function SvgAddCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 2.273a5.727 5.727 0 1 0 0 11.454A5.727 5.727 0 0 0 8 2.273M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.818 8c0-.351.285-.636.637-.636h5.09a.636.636 0 0 1 0 1.272h-5.09A.636.636 0 0 1 4.818 8",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 4.818c.351 0 .636.285.636.637v5.09a.636.636 0 0 1-1.272 0v-5.09c0-.352.285-.637.636-.637",
    clipRule: "evenodd"
  })));
};
export default SvgAddCircle;